import React, { useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setQuestionAnswer, setQuestionAnswerFrench } from "../../../../redux/actions";
import styles from "./HeatingLetterFromSNS.module.scss";
import BackAnchor from "../../../../shared/components/BackAnchor";
import { addToGoogleDataLayer } from "../../../../shared/const/utls";
import { getYearFromDate } from "../../../../helpers/utils";

const HeatingLetterFromSNSView = ({ t, i18n }) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const params = useParams();
  const disableGApush = useMemo(() => {
    return JSON.parse(params.disableGA || false);
  }, [params]);

  const datesData = useSelector((state) => state.datesReducer);

  let dates;
  if (datesData) {
    dates = datesData["en"];
  }

  const startYear = getYearFromDate(dates?.startDate);
  const endYear = startYear + 1;
  const yearRange = startYear ? startYear + "-" + endYear : "---";

  useEffect(() => {
    if (!disableGApush) {
      try {
        addToGoogleDataLayer(
          "letter-from-Service-Nova-Scotia",
          "HARP Application",
          i18n.language
        );
        window.scrollTo(0, 0);
      } catch (e) {
        console.log(e);
      }
    }
  }, [i18n.language, disableGApush]);

  const onNext = (snsLetter) => () => {
    try {
      dispatch(setQuestionAnswer(2, snsLetter === "Unknown" ? "I don't know" : snsLetter));
      dispatch(setQuestionAnswerFrench(2, snsLetter === "Unknown" ? t("shared.dont_know") : (snsLetter === 'Yes' ? t("shared.yes") : t("shared.no"))));
      if (snsLetter === "Yes") {
        navigate(`/${i18n.language}${t("routes.heating_bill_opportunity")}`);
      } else if (snsLetter === "Unknown") {
        navigate(`/${i18n.language}${t("routes.upload_bill_question")}`);
      } else {
        navigate(`/${i18n.language}${t("routes.heating_bill_not_needed")}`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReduxCleanup = () => {
    dispatch(setQuestionAnswer(2, ''));
    dispatch(setQuestionAnswerFrench(2, ''));
  }

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>

            <BackAnchor backPath={"routes.pay_heat"} onBackClick={handleReduxCleanup} />

            <div className="row">
              <div className="col-sm-8 col-xs-11">
                <h1>
                  {t("harp_questions.sns_letter").replace("#YEAR", yearRange)}
                </h1>
              </div>
            </div>

            {/* Yes/No Answer */}
            <div className="row">
              <div className="col-lg-8 ">
                <div className="col-xs-2">
                  <button
                    className={`${styles["question_button"]} btn-lg btn-default`}
                    onClick={onNext("Yes")}
                    name={t("shared.yes")}
                  >
                    {t("shared.yes")}
                  </button>
                </div>

                <div className="col-xs-4 col-lg-2 col-md-2 col-sm-2">
                  <button
                    className={`${styles["question_button"]} btn-lg btn-default smallPaddingLeft`}
                    onClick={onNext("No")}
                    value={false}
                    name={t("shared.no")}
                  >
                    {t("shared.no")}
                  </button>
                </div>

                <div className="">
                  <button
                    className={`${styles["question_button"]} btn-lg btn-default `}
                    onClick={onNext("Unknown")}
                    value={"Unknown"}
                    name={t("shared.dont_know")}
                  >
                    {t("shared.dont_know")}
                  </button>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(HeatingLetterFromSNSView);
